import { apiClient, withTagsParam } from '@/plugins/api'

export default {
  getModuleStatus(companyId, cgaTypeId) {
    const params = {}
    params.cga_type_id = cgaTypeId
    return apiClient.get(`report/company/${companyId}/get_modules_status`, params)
  },
  // TODO Per convenzione quando possibile spostare la generazione delle params all'interno della funzione
  //Ps meglio params che options, in quanto quello e' il parametro aggiuntivo di apiClient e potrebbe creare confusione
  getModulesTimes(companyId, params) {
    return apiClient.get(`report/company/${companyId}/get_modules_times`, params)
  },
  getModulesScores(companyId, params) {
    return apiClient.get(`report/company/${companyId}/get_modules_scores`, params)
  },
  getUserStatus(companyId, params) {
    return apiClient.get(`report/company/${companyId}/get_users_status`, withTagsParam(params))
  },
  getEmailsByStatus(companyId, options) {
    return apiClient.get(`report/company/${companyId}/get_emails_by_status`, withTagsParam(options))
  },
  getCompanyStats(companyId, params) {
    return apiClient.get(`report/statistics/company/${companyId}/stats`, params)
  },
  getCompanyUserAnalytics(companyId) {
    return apiClient.get(`admin/company/${companyId}/analytics`)
  },
  getModuleStatusByTeam(companyId, params) {
    return apiClient.get(`report/company/${companyId}/get_modules_status`, params)
  },
  getUserCyberScore(companyId, userId, payload) {
    return apiClient.post(`report/company/${companyId}/account/${userId}/get_cyber_score`, payload)
  },
  getCompanyCyberScore(companyId, payload) {
    return apiClient.post(`report/company/${companyId}/get_cyber_score`, payload)
  },
  getCompanyRiskScore(companyId, params) {
    return apiClient.post(`report/statistics/company/${companyId}/get_risk_score`, params)
  },
  getPhishingStats(companyId, params) {
    return apiClient.get(`report/statistics/company/${companyId}/get_phishing_stats`, withTagsParam(params))
  },
  getScoreHistory(companyId, params) {
    return apiClient.post(`report/stats_history/${companyId}/get_score_history`, params)
  },
  reportRank(companyId, team = false) {
    let opt = { responseType: 'blob', params: {} }
    if (team) opt.params.team = team
    opt.params.companyId = companyId
    opt.params.filename = !team ? 'reportRank' : 'reportTeamRank'

    return apiClient.get(`report/rank-report`, opt)
  },
  reportModuleRank(companyId) {
    return apiClient.get(`report/module-status-report?companyId=${companyId}`)
  },
  getUserRankingReport(companyId, team = null, lang = null, filename = null, file_type = null, filterTags = null) {
    let opt = {
      responseType: 'blob',
      params: {
        companyId: companyId,
        team: team,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags
      }
    }
    return apiClient.get(`report/user-ranking`, withTagsParam(opt))
  },
  getTeamRankingReport(companyId, lang = null, filename = null, file_type = null, filterTags = null) {
    let opt = {
      responseType: 'blob',
      params: {
        companyId: companyId,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags
      }
    }
    return apiClient.get(`report/team-ranking`, withTagsParam(opt))
  },
  getCompletedUserModules(companyId, team = null, service_id = null, lang = null, filename = null,
                          file_type = null, filterTags = null, start_date = null, end_date = null) {
    let opt = {
      responseType: 'blob' ,
      params: {
        companyId: companyId,
        team: team,
        service_id: service_id,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags,
        start_date: start_date,
        end_date: end_date
      }
    }
    return apiClient.get(`report/completed-user-module`, withTagsParam(opt))
  },
  reportParticipation(companyId, team = null, lang = null, filename = null, file_type = null, filterTags = null, service_id = null) {
    let opt = {
      responseType: 'blob' ,
      params: {
        companyId: companyId,
        team: team,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags,
        ...(service_id != null && { service_id: service_id })
      }
    }
    return apiClient.get(`report/participation`, withTagsParam(opt))
  },
  reportLevelDetailsParticipation(companyId,level_uuid, team = null, lang = null, filename = null, file_type = null, filterTags = null, service_id=null) {
    let opt = {
      responseType: 'blob' ,
      params: {
        companyId: companyId,
        level_uuid: level_uuid,
        team: team,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags,
        ...(service_id != null && { service_id: service_id })
      }
    }
    return apiClient.get(`report/level-participation`, withTagsParam(opt))
  },
  globalReport(companyId, service_id = null, team = null, lang = null, filterTags = null, otherParams = {}) {
    return apiClient.get(`report/company/${companyId}/global-report`, withTagsParam({
       responseType: 'blob',
       params: {
        service_id,
        team,
        lang,
        tags: filterTags,
        ...otherParams
      }
    }))
  },
  getServiceParticipation(companyId, payload) {
    return apiClient.post(`report/company/${companyId}/get_service_participation`, payload)
  },
  getUserModuleStatus(companyId, lang = null, file_type = null, service_id = null) {
    const params = {}
    if (lang) params.lang = lang
    if (file_type) params.file_type = file_type
    if (service_id) params.service_id = service_id
    let opt = { responseType: 'blob' }
    return apiClient.post(`report/company/${companyId}/get_user_module_status`, params, opt)
  },
  getUserAdditionalContents(companyId, team = null, lang = null, filename = null, file_type = null, filterTags = null){
    let opt = {
      responseType: 'blob',
      params: {
        companyId: companyId,
        team: team,
        lang: lang,
        filename: filename,
        file_type: file_type,
        tags: filterTags
      }
    }
    return apiClient.get(`report/user-additional-contents`, withTagsParam(opt))
  },
  exportCompanyList(lang, file_name) {
    const params = {}
    if (lang) params.lang = lang
    if (file_name) params.file_type = file_name
    params.responseType = 'blob'
    return apiClient.get(`report/company-report`, params)
  },
  getEmailReportStats(accountId) {
    return apiClient.get(`report/cgp_target_timeline/email/account_uuid/${accountId}`)
  },
  getPhishingEmailReportStats(accountId) {
    return apiClient.get(`report/cgp_target_timeline/account_uuid/${accountId}`)
  },
  getRiskScore(accountId) {
    return apiClient.get(`report/statistics/get_risk_score/${accountId}`)
  },
  getUserProgress(accountId) {
    return apiClient.get(`report/statistics/user_progress/${accountId}`)
  },
  getUsersStats(searchText, companyId, page, itemsPerPage, sortKey, sortDir, team, tagFilter = null) {
    const opt = {
      params: {
        search: searchText,
        _page: page,
        _limit: itemsPerPage,
        sortKey: sortKey,
        sortDir: sortDir,
        team: team,
        tags: tagFilter
      }
    }
    return apiClient.get(`report/company/${companyId}/users-stats`, withTagsParam(opt))
  },

  getOnlineUsers(companyId) {
    return apiClient.get(`report/company/${companyId}/online-users`)
  },

  aggregateDataStatsHistory(companyId,limitDate = null)
  {
    const payload = {
      companyId: companyId
    }

    if(limitDate) payload.limitDate = limitDate

    return apiClient.post(`report/stats_history/aggregate-data`, payload)
  },
  exportUserStatsList(companyId, lang, file_type, team, tags)
  {
    const opt = {
      responseType: 'blob' ,
      params: {
        lang: lang,
        file_type: file_type,
        ... team && {team},
        ... tags && {tags},
      }
    }
    return apiClient.get(`report/company/${companyId}/users-stats-report`, withTagsParam(opt))
  },
  getLevelProgressSummary(companyId, levelId, params) {
    return apiClient.get(`report/company/${companyId}/level/${levelId}/summary`, { params })
  },
  exportLevelProgress(companyId, levelId) {
    return apiClient.get(`report/company/${companyId}/level/${levelId}/export`)
  },
  getLevelAccount(companyId, levelId) {
    return apiClient.get(`report/company/${companyId}/level/${levelId}/account`)
  },
  getCompanyChampionships(params) {
    return apiClient.get(`report/championships`, { params })
  },
  createCompanyChampionship(companyId, championship) {
    let params = { ...championship, companyId: companyId }
    return apiClient.post(`report/championships`, params)
  },
  editCompanyChampionship(companyId, championship) {
    let params = { ...championship }
    const level_uuid = championship.level_uuid;
    return apiClient.put(`report/championships?companyId=${companyId}&levelUuid=${level_uuid}`, params)
  },
  deleteCompanyChampionship(companyId, championshipLevelUuid) {
    return apiClient.delete(`report/championships?companyId=${companyId}&levelUuid=${championshipLevelUuid}`)
  },
  exportIndividualChampionship(companyId, championshipLevelUuid, team = null, lang = null, filename = null, filetype = null, filterTags = null){
    const opt = {
      responseType: 'blob' ,
      params: {
        companyId: companyId,
        levelUuid: championshipLevelUuid,
        team: team,
        lang: lang,
        filename: filename,
        filetype: filetype,
        tags: filterTags
      }
    }
    return apiClient.get(`report/championships/user-ranking`, withTagsParam(opt))
  },
  exportTeamChampionship(companyId, championshipLevelUuid, lang = null,  filename = null, filetype = null, filterTags = null){

    let opt = {
      responseType: 'blob',
      params: {
        companyId: companyId,
        levelUuid: championshipLevelUuid,
        lang: lang,
        filename: filename,
        filetype: filetype,
        tags: filterTags
      }
    }
    return apiClient.get(`report/championships/team-ranking`, withTagsParam(opt))
  },
  getMantraServices(companyId) {
    return apiClient.get(`report/company/${companyId}/mantra/services`)
  }
}
